export enum Cultures {
    it_IT = 0,
    en_US = 1,
    es_ES = 2,
    de_DE = 3,
    pl_PL = 4,
    pt_BR = 5,
    bg_BG = 6,
    ru_RU = 7,
}

export enum ArrangementType {
    SixXTwo = 0,
    TwelveXOne = 1,
    ThreeXFour = 2,
    SixXOnePrecordial = 3,
    SixXOnePeripheral = 4,
    Medians = 5,
    XXTwo = 6,
    XXOne = 7,
}

export enum TimeAlignment {
    Sequential = 0,
    Simultaneous = 1,
}

export enum PaperRate {
    mm25 = 0,
    mm50 = 1,
}

export enum GuidedComparisonType {
    TraceToTrace = 0,
    Overlapping = 1,
    ExamToExam = 2,
    SideBySide = 3,
}

export enum Format {
    standard = 0,
    cabrera = 1,
}

export enum CaliperMode {
    single = 0,
    multi = 1,
}
